// extracted by mini-css-extract-plugin
export default {"pagination_wrapper":"CustomPagination_pagination_wrapper__G2W80"};